import { usePublicSurveySaveMutation } from "../../../api/surveys/usePublicSurveySaveMutation";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { uiNotification } from "../../../services/UINotificationService";
import { extractApiError } from "../../../utilities/api";

export function useSubmit() {
  var { tSurvey: t } = useAppTranslation.Survey();

  var { mutate, isLoading } = usePublicSurveySaveMutation({
    onError: (res) => {
      const message = extractApiError(res);
      uiNotification.error(t([`error.${message}`, "error.submit"]));
    },
  });

  var validate = ({ questions, answers }) => {
    var answers_ = Object.entries(answers).reduce(
      (acc, [k, v]) => ({
        ...acc,
        [k]: Array.isArray(v) ? v.map((a) => a?.trim()) : v?.trim(),
      }),
      {},
    );

    var requiredQuestionIds = questions
      .filter((q) => q.isRequired)
      .map((q) => String(q.id));

    var answeredQuestionIds = Object.entries(answers_)
      .filter(([_, v]) => (Array.isArray(v) ? v.length > 0 : !!v))
      .map(([k, _]) => String(k));

    return requiredQuestionIds.every((id) => answeredQuestionIds.includes(id));
  };

  var createQuestionsMap = (questions) =>
    questions.reduce((acc, question) => {
      acc[question.id] = question;
      return acc;
    }, {});

  var initiate = ({ hash, survey, answers, comments }) => {
    var { questions } = survey;

    if (!validate({ questions, answers })) {
      uiNotification.error(t("error.required_questions"));
      return;
    }

    var questionsMap = createQuestionsMap(questions);

    mutate({
      hash,
      patientId: survey.patientId,
      accountId: survey.accountId,
      answers: Object.entries(answers).map(([questionId, answers]) => ({
        questionId: Number(questionId),
        questionType: questionsMap[questionId].type,
        questionText: questionsMap[questionId].question,
        answers: Array.isArray(answers) ? answers : [answers],
        comment: comments[questionId] || "",
      })),
    });
  };

  return {
    initiate,
    isLoading,
  };
}
